import { useContext } from 'react';
import { PromptLibraryContext } from './Context';
export const usePromptLibrary = () => {
    const context = useContext(PromptLibraryContext);
    if (!context) {
        throw new Error('usePromptLibrary hook used outside <PromptLibraryProvider />');
    }
    return context;
};
